module.exports = __webpack_public_path__ + "img/text.722f8696.svg";